import React, { createElement, render } from 'preact';

// import React from 'react';
// import ReactDOM from 'react-dom';
// import { BrowserRouter as Router } from 'react-router-dom';
import App from './app';
import CreateReview from './containers/create_review';
import { WIDGET_SCRIPT_ID } from './config/keys';

const testAccessToken = 'db9e6d2b-90d3-4091-ba20-4f82cee203a6';
const testMemberID = '69685';
const testBranding = 'apfm';
const testHeaderFooter = 'true';
const testWebsiteUserID = '123';
const testDomainOwnerID = '1';

const createReview: any = CreateReview;

const widgetAttrMap = new Map([
    ['createreview', createReview]
]);

interface tgWindow extends Window {
    tgReviewWidget: object;
}

declare const window: tgWindow;

const renderWithClientRouter = () => {

    render(
        <App 
            Widget={null}
            accessToken={testAccessToken}
            memberID={testMemberID}
            branding={testBranding}
            headerFooter={testHeaderFooter}
            websiteUserID={testWebsiteUserID}
        />,
        document.getElementById('root')!
    );
};

const renderWidget = (widget: any, accessToken: string, memberID: string, id: string, 
    branding: string, headerFooter: string, websiteUserID: string, domainOwnerID: string) => {

    render(
        <App 
            Widget={widget}
            ref={tgReviewWidget => { 
                window['tgReviewWidget'] = tgReviewWidget;
            }} 
            accessToken={accessToken}
            memberID={memberID}
            branding={branding}
            headerFooter={headerFooter}
            websiteUserID={websiteUserID}
            domainOwnerID={domainOwnerID}
        />,
        document.getElementById(id)!
    );
};

const renderWidgets = () => {

    const script = document.getElementById(WIDGET_SCRIPT_ID);

    if (!script) {
        console.log(`script tag with ID: ${WIDGET_SCRIPT_ID} not found`);
        return;
    }

    const accessToken: string = script.dataset.access || '';
    const memberID: string = script.dataset['memberid'] || '';
    const branding: string = script.dataset['theme'] || '';
    const headerFooter: string = script.dataset['headerfooter'] || '';
    const websiteUserID: string = script.dataset['websiteuserid'] || '';
    const domainOwnerID: string = script.dataset['domainownerid'] || '';

    for (const [widgetName, widgetRootStr] of Object.entries(script.dataset)) {
        const widget = widgetAttrMap.get(widgetName);

        if (widget) {
            const widgetRootIDs = (widgetRootStr || '').split(',');

            widgetRootIDs.forEach(id => {
                console.log(`USING Widget: ${widgetName} at ID: ${id}`);
                renderWidget(widget, accessToken, memberID, id.trim(), branding, headerFooter, websiteUserID, domainOwnerID);
            });
        }
    }
};

const main = (() => {

    const useClientRouter = process.env.REACT_APP_USE_CLIENT_ROUTER;

    if (useClientRouter) {
        renderWithClientRouter();
    } else {
        renderWidgets();
    }

})();
